import React from 'react';
import IconsGridCard from './IconsGridCard';

const CategoriesAndBrandsCard = ({ card }) => {

    return (
        <IconsGridCard card={card} />
    );
};

export default CategoriesAndBrandsCard;
